import { useEffect, useRef, useState } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface JobTitleProps {
  title: string;
}

export const JobTitle = ({ title }: JobTitleProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = titleRef.current;
    if (!element) return;

    const observer = new ResizeObserver(() => {
      const isTruncated = element.scrollWidth > element.clientWidth;
      setShowTooltip(isTruncated);
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [title]);

  return (
    <div
      ref={titleRef}
      className="text-sm leading-5 flex-[8] min-w-0 content-start items-start justify-start text-left truncate"
    >
      {showTooltip ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span>{title}</span>
            </TooltipTrigger>
            <TooltipContent>
              <p>{title}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        title
      )}
    </div>
  );
};
